import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';

import { Configuration } from './index.model';

//import { Http_Header_Request_Options } from '../core/httpheader';
import { HttpHeader } from '../core/httpheader';

import data from '../../assets/config/config.json'

@Injectable()
export class ConfigService {
    private config: Configuration;
    constructor(private http: Http) { }

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    load(url: string) {
        // ---------------   commented for Path reference test ------------------
        //this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        //return new Promise((resolve) => {
        //    this.http.get(url, this.Http_Header_Request_Options).map(res => res.json())
        //        .subscribe(config => {
        //            this.config = config;
        //            console.log(this.config);
        //            resolve();
        //        });
        //});
        //---------------------------------------------------------


        // ----------------- added for Path reference test
        this.config = data;
        //console.log(this.config);
        // -------------------------------------------------------------
    }

    getConfiguration(): Configuration {
        return this.config;
    }

}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/config.service.ts